module.exports = __webpack_public_path__ + "static/media/pincil-request.245ad170.png";